import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { useCreateSectionImplementedMutation } from "slices/resourceInventory/inventorySlice";
import { Formik, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";

interface ImplementedModalProps {
  isOpen: boolean;
  toggle: () => void;
  productId: number | string;
  refetchInventory: () => void;
}

const ImplementedModal: React.FC<ImplementedModalProps> = ({
  isOpen,
  toggle,
  productId,
  refetchInventory,
}) => {
  const [createSectionImplemented, { isLoading: isCreating }] =
    useCreateSectionImplementedMutation();

  const validationSchema = Yup.object({
    quantity: Yup.number().required("Quantity is required"),
    activity_log: Yup.string().required("Activity log is required"),
    comments: Yup.string().required("Comments are required"),
  });

  const initialValues = {
    quantity: "",
    activity_log: "",
    comments: "",
  };

  const handleSubmit = async (
    values: typeof initialValues,
    { resetForm }: { resetForm: () => void },
  ) => {
    try {
      await createSectionImplemented({
        ...values,
        product: productId,
      });
      toggle();
      refetchInventory();
      resetForm();
    } catch (error) {
      console.error("Error adding implemented section:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Implemented Section</ModalHeader>
      <hr />
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleChange, handleBlur, values }) => (
            <FormikForm>
              <FormGroup>
                <Label for="quantity">Quantity</Label>
                <Input
                  type="text"
                  id="quantity"
                  name="quantity"
                  value={values.quantity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <ErrorMessage
                  name="quantity"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>
              <FormGroup>
                <Label for="activity_log">Activity Log</Label>
                <Input
                  type="textarea"
                  id="activity_log"
                  name="activity_log"
                  value={values.activity_log}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <ErrorMessage
                  name="activity_log"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>
              <FormGroup>
                <Label for="comments">Comments</Label>
                <Input
                  type="textarea"
                  id="comments"
                  name="comments"
                  value={values.comments}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                <ErrorMessage
                  name="comments"
                  component="div"
                  className="text-danger"
                />
              </FormGroup>
              <ModalFooter>
                <Button
                  color="primary"
                  type="submit"
                  onClick={() =>
                    document.forms[0].dispatchEvent(new Event("submit"))
                  }
                  disabled={isCreating}
                >
                  {isCreating ? (
                    <>
                      <Spinner size="sm" />
                      &nbsp;Saving...
                    </>
                  ) : (
                    "Save Changes"
                  )}
                </Button>
                <Button
                  color="secondary"
                  onClick={toggle}
                  disabled={isCreating}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </FormikForm>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default ImplementedModal;
